import Header from "@/components/Header";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import WhatWeDo from "@/components/WhatWeDo";
import WhyChooseUs from "@/components/WhyChooseUs";
import ContactBar from "@/components/ContactBar";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import { useContent } from "@/content/ContentContext";
import { buildHomeFaqs, resolveFaqs } from "@/content/faqData";
import { PAGE_META } from "@/content/seoData";

const sectionComponents = {
  hero: Hero,
  stats: StatsBar,
  whatwedo: WhatWeDo,
  whychoose: WhyChooseUs,
};

const Home = () => {
  const c = useContent();
  const order = c.home.sectionOrder.filter((id) => sectionComponents[id]);

  return (
    <div className="App">
      <Seo title={PAGE_META.home.title} description={PAGE_META.home.description} path="/" />
      <Header />
      <main>
        {order.map((id) => {
          const Section = sectionComponents[id];
          return <Section key={id} />;
        })}
        <FAQSection items={resolveFaqs(c, "home", buildHomeFaqs(c))} />
      </main>
      <ContactBar />
      <Footer />
    </div>
  );
};

export default Home;
